define(["exports", "../core/l10n", "./pubsubhub"], function (_exports, _l10n, _pubsubhub) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.run = run;
  _exports.name = void 0;

  function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  const name = "core/github";
  _exports.name = name;
  const localizationStrings = {
    en: {
      file_a_bug: "File a bug",
      participate: "Participate",
      commit_history: "Commit history"
    },
    nl: {
      commit_history: "Revisiehistorie",
      file_a_bug: "Dien een melding in",
      participate: "Doe mee"
    },
    es: {
      commit_history: "Historia de cambios",
      file_a_bug: "Nota un bug",
      participate: "Participe"
    }
  };
  const lang = _l10n.lang in localizationStrings ? _l10n.lang : "en";
  const l10n = localizationStrings[lang];

  async function run(conf) {
    if (!conf.hasOwnProperty("github") || !conf.github) {
      // nothing to do, bail out.
      return;
    }

    if (typeof conf.github === "object" && !conf.github.hasOwnProperty("repoURL")) {
      const msg = "Config option `[github](https://github.com/w3c/respec/wiki/github)` " + "is missing property `repoURL`.";
      (0, _pubsubhub.pub)("error", msg);
      return;
    }

    let tempURL = conf.github.repoURL || conf.github;
    if (!tempURL.endsWith("/")) tempURL += "/";
    let ghURL;

    try {
      ghURL = new URL(tempURL, "https://github.com");
    } catch (_unused) {
      (0, _pubsubhub.pub)("error", "`respecConf.github` is not a valid URL? (".concat(ghURL, ")"));
      return;
    }

    if (ghURL.origin !== "https://github.com") {
      const msg = "`respecConf.github` must be HTTPS and pointing to GitHub. (".concat(ghURL, ")");
      (0, _pubsubhub.pub)("error", msg);
      return;
    }

    const [org, repo] = ghURL.pathname.split("/").filter(item => item);

    if (!org || !repo) {
      const msg = "`respecConf.github` URL needs a path with, for example, w3c/my-spec";
      (0, _pubsubhub.pub)("error", msg);
      return;
    }

    const branch = conf.github.branch || "gh-pages";
    const issueBase = new URL("./issues/", ghURL).href;
    const newProps = {
      edDraftURI: "https://".concat(org.toLowerCase(), ".github.io/").concat(repo, "/"),
      githubToken: undefined,
      githubUser: undefined,
      issueBase,
      atRiskBase: issueBase,
      otherLinks: [],
      pullBase: new URL("./pulls/", ghURL).href,
      shortName: repo
    };
/* EEA specStatus */
/* If specStatus is not EEA (that is, it's a W3C spec) assign the "Participate" links, otherwise don't */
    if (conf.specStatus !== "EEA") {
      const otherLink = {
        key: l10n.participate,
        data: [{
          value: "GitHub ".concat(org, "/").concat(repo),
          href: ghURL
        }, {
          value: l10n.file_a_bug,
          href: newProps.issueBase
        }, {
          value: l10n.commit_history,
          href: new URL("./commits/".concat(branch), ghURL.href).href
        }, {
          value: "Pull requests",
          href: newProps.pullBase
        }]
      }; // Assign new properties, but retain existing ones
    }

    let githubAPI = "https://respec.org/github/".concat(org, "/").concat(repo, "/");

    if (conf.githubAPI) {
      if (new URL(conf.githubAPI).hostname === window.parent.location.hostname) {
        // for testing
        githubAPI = conf.githubAPI;
      } else {
        const msg = "`respecConfig.githubAPI` should not be added manually.";
        (0, _pubsubhub.pub)("warn", msg);
      }
    }

    const normalizedGHObj = {
      branch,
      repoURL: ghURL.href
    };

    const normalizedConfig = _objectSpread({}, newProps, {}, conf, {
      github: normalizedGHObj,
      githubAPI
    });

    Object.assign(conf, normalizedConfig);
    conf.otherLinks.unshift(otherLink);
  }
});
//# sourceMappingURL=github.js.map